const FileList = [
  { order: 0, id: 0, fieldName: "/EMPLOYEE ID", datum: "E025", type: 1 },
  {
    order: 1,
    id: 1,
    fieldName: "/PAY DATE",
    datum: "01-04-2021 00:00:00",
    type: 4,
  },
  { order: 2, id: 2, fieldName: "/SSN", datum: "888-44-3025", type: 1 },
  { order: 3, id: 3, fieldName: "/FIRST NAME", datum: "Sriram q", type: 1 },
  { order: 4, id: 4, fieldName: "/LAST NAME", datum: "S", type: 1 },
  { order: 5, id: 5, fieldName: "/MIDDLE INITIAL", datum: "S", type: 1 },
  { order: 6, id: 6, fieldName: "/GENDER", datum: "F", type: 1 },
  { order: 7, id: 7, fieldName: "/MARITAL STATUS", datum: "S", type: 1 },
  {
    order: 8,
    id: 8,
    fieldName: "/BIRTH DATE",
    datum: "19-09-1980 00:00:00",
    type: 4,
  },
  {
    order: 9,
    id: 9,
    fieldName: "/FOREIGN ADDRESS INDICATOR",
    datum: "N",
    type: 1,
  },
  { order: 10, id: 10, fieldName: "/ADDRESS 1", datum: "AAASAM", type: 1 },
  { order: 11, id: 11, fieldName: "/ADDRESS 2", datum: "SampleAddr2", type: 1 },
  { order: 12, id: 12, fieldName: "/ADDRESS 3", datum: "SampleAddr3", type: 1 },
  { order: 13, id: 13, fieldName: "/CITY", datum: "SampleCity", type: 1 },
  { order: 14, id: 14, fieldName: "/COUNTRY", datum: "USA", type: 1 },
  { order: 15, id: 15, fieldName: "/STATE", datum: "NY", type: 1 },
];

export default FileList;
